import {SportHallen} from './sporthallen'
import {applyMixins} from './utils'
import {Base} from './base'
import {Verenigingen} from "./verenigingen";
import {Teams} from "./teams";
import {Poules} from "./poules";
import {Wedstrijden} from "./wedstrijden";
import {Searching} from "./search";

class NevoboJs extends Base {
}

interface NevoboJs extends SportHallen, Verenigingen, Teams, Poules, Wedstrijden, Searching {
}

applyMixins(NevoboJs, [SportHallen, Verenigingen, Teams, Poules, Wedstrijden, Searching]);

export default NevoboJs
